var _defs, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameTickConfrimLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .tickline {\n        fill: none;\n        /* stroke: #333; */\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.33px;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "tickline",
    points: "6.96 29.16 20.49 41.65 43.04 8.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameTickConfrimLine);
export default __webpack_public_path__ + "static/media/Game_tick_confrim_line.fb4a483cd47d8722ea5c6b194b62ab83.svg";
export { ForwardRef as ReactComponent };